import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_algae_cooking_club_nara_roasted_garlic_oil: FaireProductEntity =
  {
    token: "p_live_algae_cooking_club_nara_roasted_garlic_oil",
    type: "product",
    name: "Nara's Roasted Garlic Oil",
    brandToken: "b_live_algae_cooking_club",
    brandName: "Algae Cooking Club",
    imageUrl:
      "https://cdn.faire.com/fastly/d68375b744e028c5f276f9290fc4a313f3b57326106f5ab40584975e16a46ab7.png?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
    priceDollars: 8.5,
    msrpDollars: 17,
    description:
      "Algae Cooking Club roasted garlic oil used in Live Shopping mocks.",
    categoryTokens: ["cat_food-drink"],
    tags: ["live-shopping", "new", "oils"],
    isNew: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T00:00:00.000Z",
      importedBy: "live-shopping-migration",
    },
  };
